import React, { Fragment } from 'react';
import ReactDOM from 'react-dom';
import Fa from "react-fa";
import { withSiteData, NavLink, Link, withRouteData, Head } from 'react-static'
import { LazyImage } from 'react-lazy-images'
import Wrapper from "../styles/contact.style.js";
import { Translate, withLocalize } from 'react-localize-redux'
import global from "../translations/global.json";
import CountryCode, { json } from "../shared-components/country-code.jsx";
import jobList from "../../public/job-list.json";
import { baseURL } from "../helpers/utils.js";
import axios from 'axios';


class ContactPage extends React.PureComponent{
  constructor(props){
    super(props);
    const { activeLanguage } = props;
    const selector = ((activeLanguage && activeLanguage.code) === "fr") ? 1 : 0;
    this.state = {
      selector,
      form: {
        countryCode: json[0].dial_code,
        "you-are": global.formPlaceholders.roles.one[selector]
      },
      innerWidth: typeof window !== "undefined" && window.innerWidth
    }
  }

    onSubmit = e => {

      e.preventDefault();
      this.setState({ busy: true });

      axios.post(baseURL + "contact", this.state.form).then(response => {
        this.setState({ success: true, message: response.data.message || response.message });
        setTimeout(() => this.setState({  busy: false }), 3000);
      }).catch(response => {
        this.setState({  success: false, message: response.error });
        setTimeout(() => this.setState({  busy: false }), 3000);
      });

    }

    setText = e => {
      const { value } = e.target;
      const inputName = e.target.getAttribute("data-name");
      this.setState(prev => {
        return { ...prev, form: {...prev.form, [inputName]: value}}
      })
    }

  componentDidMount () {
    if (typeof window !== "undefined") {
      window.addEventListener("resize", this.resizeEventListener);
    }
  }

  resizeEventListener = () => {
    if (typeof window !== "undefined") {
      this.setState({
        innerWidth: window.innerWidth
      });
    }
  };


  render(){

    const { options, busy, success, message, selector } = this.state;
    const { activeLanguage } = this.props;
    const { innerWidth =  typeof window !== "undefined" && window.innerWidth } = this.state;

    return (
      <Wrapper>
        <div className="xs-12" id="contact-page">

          <section className="xs-12 header">
            <div className="xs-12 md-11" style={{ margin: "auto" }}>
            <h3><Translate id="contact.heading"/> </h3>
            <p><Translate id="contact.sub-heading"/> </p>
            </div>
          </section>

          <section className="xs-12 content">

            <div className="xs-12 md-4 flex-wrap">
              <p className="text-content"><Translate id="contact.content.left"/></p>
            </div>

            <div className="xs-12 md-7 md-off-1">
              <section className="xs-12 form-content">

                <form className="xs-12" onSubmit = {this.onSubmit} enctype="multipart/form-data"
                method="POST" name="contact" data-netlify="true">


                  <div className = "xs-12 md-6">

                    <div className = "xs-12 form-control">
                      <label htmlFor="nom">{global.formPlaceholders.careers.firstname[selector]}</label>
                      <input placeholder = {global.formPlaceholders.careers.firstname[selector]}
                      data-name ="nom" type ="text" onChange = {this.setText} required/>
                    </div>

                    <div className = "xs-12 form-control">
                      <label htmlFor="prenom">{global.formPlaceholders.careers.lasttname[selector]}</label>
                      <input placeholder = {global.formPlaceholders.careers.lasttname[selector]}
                      data-name ="prenom" type ="text" onChange = {this.setText} required/>
                    </div>

                  </div>

                  <div className="xs-12 md-6 form-control">
                    <label>Email</label>
                    <input className = "xs-12"
                    placeholder={global.formPlaceholders.contactUsPlaceholders.email[selector]}
                    data-name="email" onChange = {this.setText}/>
                  </div>

                  <div className="xs-12 md-6 form-control">
                    <label><Translate id="contact.role"/></label>
                    <select className = "xs-12"
                    data-name="you-are"
                    onChange = {this.setText} >
                      <option>{global.formPlaceholders.roles.one[selector]}</option>
                      <option>{global.formPlaceholders.roles.two[selector]}</option>
                      <option>{global.formPlaceholders.roles.three[selector]}</option>
                      <option>{global.formPlaceholders.roles.four[selector]}</option>
                    </select>
                  </div>

                  <div className='xs-12 cjsx'>
                      <div className ="xs-12 md-4 form-control">
                        <label><Translate id="contact.countrycode"/></label>
                        <CountryCode defaultValue={json[0].dial_code} onChange={this.setText} />
                      </div>
                      <div className ="xs-12 md-8 form-control">
                        <label><Translate id="contact.phone"/></label>
                        <input type="tel"
                        className = "xs-12"
                        placeholder={global.formPlaceholders.contactUsPlaceholders.telephone[selector]}
                        data-name="telephone"
                        onChange = {this.setText}/>
                      </div>
                  </div>

                  <div className="xs-12 form-control">

                    <label>Message</label>

                    <textarea
                    className = "xs-12"
                    placeholder={global.formPlaceholders.contactUsPlaceholders.message[selector]}
                    onChange = {this.setText}
                    data-name="message"
                    />

                  </div>

                  <div className = "xs-12 form-control t-c">

                    { busy ?
                      <Fragment>
                        <button
                        disabled={busy}
                        id="submit"
                        style={{
                          background: "white",
                          border: "2px solid lightgray",
                          color: "#444",
                          cursor: "spinner"
                        }}>
                          <Translate id="contact.pleaseWait"/>
                          <Fa icon name="spinner" spin={true}/>
                        </button>
                      </Fragment>
                      :
                      <Fragment>
                          <button id="submit" disabled={busy}>
                            <Translate id="contact.button"/>
                          </button>
                      </Fragment>
                    }

                    {
                      !busy && (
                        <p style={{ padding: '9px 0 0', fontSize: '13px', color: success ? 'cadetblue':'red' }}>
                          { success ? <Translate id="home.successMessage"/> : message }
                        </p>)
                      }
                  </div>

                </form>

              </section>
            </div>

          </section>

        </div>
      </Wrapper>
    )
  }

}

export default withLocalize(ContactPage);



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/Contact.jsx